// Module
var code = `<div class="filters" ng-if="\$ctrl.hasFilterAndPrint(\$ctrl.productType)">
  <div class="labelled-field labelled-field--long">
    <label>Date from</label>
    <date max="\$ctrl.dateTo" ng-model="\$ctrl.dateFrom"></date>
  </div>
  <div class="labelled-field labelled-field--long">
    <label>Date to</label>
    <date min="\$ctrl.dateFrom" ng-model="\$ctrl.dateTo"></date>
  </div>

  <button class="btn btn-info" ng-click="\$ctrl.resetTransactions()">Filter</button>
  <button class="btn btn-print" ng-click="\$ctrl.onPrintOrDownload()">
    {{\$ctrl.buttonLabel()}}
  </button>
  <div class="btn-group" ng-if="\$ctrl.enableRealServerDateTimeFilter">
    <button class="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"> {{\$ctrl.selectedDateOption || 'System Date'}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu">
      <li>
        <a ng-click="\$ctrl.setDateOption('System Date')">System Date</a>
      </li>
      <li>
        <a ng-click="\$ctrl.setDateOption('Realtime Server Date')">Realtime Server Date</a>
      </li>
    </ul>
  </div>
</div>
<table class="table no-print" ng-table="\$ctrl.transactionHistoryConfig">
  <thead>
  <tr>
    <th>No</th>
    <th>Date and time</th>
    <th ng-if="\$ctrl.displayRealServerDateTime">Real server date time</th>
    <th>Type</th>
    <th>Code</th>
    <th>Status</th>
    <th>Amount</th>
    <th ng-if="!\$ctrl.hideTotalBalanceAfter">Total balance after</th>
    <th ng-if="!\$ctrl.hideAvailableBalanceAfter">Available balance after</th>
  </tr>
  </thead>
  <tbody>
    <tr ng-repeat-start="item in \$data"
        class="table__row--clickable"
        ng-click="\$ctrl.transactionClicked(item, \$event)"
        ng-class="{'selected': \$ctrl.selectedTransactionId === item.id}">
      <td>{{\$index+1 + (\$ctrl.transactionHistoryConfig.page() - 1) * \$ctrl.transactionHistoryConfig.count()}} </td>
      <td>{{(item.processedOn || item.registrationTime) | prettyDateTime }}</td>
      <td ng-if="\$ctrl.displayRealServerDateTime">{{item.realServerDateTime | prettyDateTime }}</td>
      <td class="type-{{item.entryType}}">{{\$ctrl.translate(item)}}</td>
      <td>{{\$ctrl.getOperationCode(item) | translate:'OPERATION_SHORT_CODE':'-'}}</td>
      <td class="status-{{item.transactionStatusLabel | uppercase}}">
        {{item.transactionStatusLabel}}
      </td>
      <td>{{item.amount | nxCurrency:'dashOnZero'}}</td>
      <td ng-if="!\$ctrl.hideTotalBalanceAfter">{{item.balanceAfter + item.holdsAfter | nxCurrency:'dashOnZero'}}</td>
      <td ng-if="!\$ctrl.hideAvailableBalanceAfter">{{item.balanceAfter | nxCurrency:'dashOnZero'}}</td>
    </tr>
    <tr ng-repeat-end class="table__row--not-hoverable">
      <td colspan="100%">
        <div class="toggleable-panel-wrapper"
             ng-class="{'toggleable-panel-wrapper--toggled': \$ctrl.selectedTransactionId === item.id}">
          <inline-panel on-hide="\$ctrl.hideInlinePanel()">
            <div class="transclude" ng-transclude></div>
          </inline-panel>
        </div>
      </td>
    </tr>
  </tbody>
</table>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/transaction-history/transaction-history.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;